<template>
  <CoursesEnciteItem
    :pageTitle="'Online Courses CMMC Level 1'"
    :courseTitle="'CMMC Level 1'"
    :courseItems="items"
    :informationCardColor="'#00AFF7'"
    :informationCardTextColor="'#001426'"
  />
</template>
<script>
import CoursesEnciteItem from "./courses-encite-item.vue";
import { enciteCMMCLevel1Courses } from "../utils/coursesEnciteData";

export default {
  name: "encite-courses",
  components: {
    CoursesEnciteItem,
  },
  props: {
    query: String,
  },
  data() {
    return {
      items: enciteCMMCLevel1Courses,
    }
  },
}
</script>
